import MarketEvolution from '../../../../common/src/sections/home/MarketEvolution';

const EvolutionMarketPage = () => {
  return (
    <div className=''>
      <MarketEvolution />
    </div>
  );
};

export default EvolutionMarketPage;
